import React, { Component } from 'react'

class Scholars extends Component {
    render(){
        return(
            <div className=' w3-container my-profile-container'>
                <h4 className='w3-center'><b>Project Research Scholars</b></h4>
                <div className=' w3-row w3-card-2 w3-white w3-round-large w3-center w3-margin-bottom'>
                    <div className='w3-quarter w3-padding'>
                        <img src='./images/shwetank.jpg' className='my-card-img' alt='shwetank' />
                    </div>
                    <div className='w3-threequarter w3-padding'>
                    <table className="w3-table-all"  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan='2'>Shwetank Agrawal</th>
                                
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><b>Institute:</b></td>
                                <td> IIT Roorkee, India</td>
                               
                            </tr>
                            <tr>
                                <td><b>Department:</b></td>
                                <td> Electrical Engineering Department</td>
                               
                            </tr>
                            <tr>
                                <td><b>Responsibilities:</b></td>
                                <td> Design, PCB fabrication and testing of gate driver, signal conditioning circuit for voltage and Current sensor, signal and power board, trip and latch circuit. Transformer design spcification and testing. Modeling and simulaton of different system component. Controller Design for proper operation among different converters.
                                    Islanded and Grid Connected Simulation and hardware setup. Master Inverter control. Battery specification and testing. Programmable DC load specificationa and testing. Custom Rack design and fabrication for Hybrid Microgrid. SPV and Main Electrical Panel Installation. Inductor and Capacitor calculation for qZSI. Cable layout Design, Wiring and different component(like IGBT's, driver, trip circuit, sensors etc.) allocation and mounting. Project Website Design and management. Different Component order and vendor management.   </td>
                            </tr>
                            <tr>
                                <td><b>Role:</b></td>
                                <td>JRF(2018-20) & PhD Scholar(2019 onwards) </td>
                                
                            </tr>
                          
                            </tbody>
                        </table>  
                    </div>
                </div>
                <div className=' w3-row w3-card-2 w3-white w3-round-large w3-center w3-margin-bottom'>
                    <div className='w3-quarter w3-padding'>
                        <img src='./images/yangya.jpg' className='my-card-img' alt='yangya' />
                    </div>
                    <div className='w3-threequarter w3-padding'>
                    <table className="w3-table-all"  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan='2'>Yangyadatta Tripathy</th>
                                
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><b>Institute:</b></td>
                                <td> IIT Roorkee, India</td>
                               
                            </tr>
                            <tr>
                                <td><b>Department:</b></td>
                                <td> Electrical Engineering Department</td>
                               
                            </tr>
                            <tr>
                                <td><b>Responsibilties:</b></td>
                                <td> Modeling and Simulation of the different component. Testing of different components like Battery, Programmable DC load, Master Inverter, current and voltage sensor, transformer, power board etc.. Custom rack fabrication for Hybrid Microgrid. Controller Design for proper operation among different converters. </td>
                            </tr>
                            <tr>
                                <td><b>Role:</b></td>
                                <td>JRF(2019-2020) & PhD Scholar(2020 onwards)</td>
                                
                            </tr>
                          
                            </tbody>
                        </table>  
                    </div>
                </div>
                <div className=' w3-row w3-card-2 w3-white w3-round-large w3-center w3-margin-bottom'>
                    <div className='w3-quarter w3-padding'>
                        <img src='./images/uzair.jpg' className='my-card-img' alt='uzair' />
                    </div>
                    <div className='w3-threequarter w3-padding'>
                    <table className="w3-table-all"  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan='2'>Uzair Malik</th>
                                
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><b>Institute:</b></td>
                                <td > IIT Roorkee, India</td>
                               
                            </tr>
                            <tr>
                                <td><b>Department:</b></td>
                                <td > Electrical Engineering Department</td>
                               
                            </tr>
                            <tr>
                                <td><b>Responsibilities:</b></td>
                                <td > Simulation of the different component. Testing of different components like Battery, Programmable DC load, Master Inverter, current and voltage sensor, transformer etc.. Custom rack fabrication for Hybrid Microgrid. SPV Installation , Main and different Electrical Panel Installation, Cable layouting and Earthing. Controller Design for proper operation among different converters. DC-DC converter inductor calculation. Filter Design for AC System. Different order and Vendor Management</td>
                            </tr>
                            <tr>
                                <td><b>Role:</b></td>
                                <td>PhD Scholar(2019 onwards)[Volunteer Support 2021 onwards]</td>
                                
                            </tr>
                            </tbody>
                        </table>  
                    </div>
                </div>
                <div className=' w3-row w3-card-2 w3-white w3-round-large w3-center w3-margin-bottom'>
                    <div className='w3-quarter w3-padding'>
                        <img src='./images/roushan.png' className='my-card-img' alt='roushan' />
                    </div>
                    <div className='w3-threequarter w3-padding'>
                    <table className="w3-table-all"  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan='2'>Roushan Kumar Mishra</th>
                                
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><b>Institute:</b></td>
                                <td > IIT Roorkee, India</td>
                               
                            </tr>
                            <tr>
                                <td><b>Department:</b></td>
                                <td > Electrical Engineering Department</td>
                               
                            </tr>
                            <tr>
                                <td><b>Responsibilities:</b></td>
                                <td >Modeling and Simulation of the different component. Testing of different components like current and voltage sensor, transformer etc. Controller Design for proper operation among different converters. DC-DC converter inductor calculation. Filter Design for AC System.   </td>
                            </tr>
                            <tr>
                                <td><b>Role:</b></td>
                                <td>PhD(2019 Onwards)[Volunteer Support 2021 onwards]</td>
                                
                            </tr>
                            </tbody>
                        </table>  
                    </div>
                </div>
                
               
                


            </div>
        )
    }
}

export default Scholars